module.exports = __webpack_public_path__ + "img/animals_04_H.92fdc18b.webp";